/* @flow */

import ApolloClient from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { API } from '../utils/constants';
import getTokenApi from '../login/get-token-api';

const loggiClient = new ApolloClient({
    link: new HttpLink({
        uri: `${API}/empresa/graphql-loggi`,
        headers: {
            Authorization: getTokenApi(),
        },
    }),
    cache: new InMemoryCache(),
    connectToDevTools: false,
});

export default loggiClient;
